import {createElement, Component, PropTypes} from 'rlink-react';
import pathlib from 'path';
import formattedImgPath from 'rlink-repos/formattedImgPath';
import connectToPathForContent from 'rlink-repos/connectToPathForContent';
import ContentImg from 'rlink-repos/components/ContentImg.jsx';

class Picture extends Component {
  renderSources (largest) {
    let sources = [];
    for (let {contentType, fileExt} of this.props.formats) {
      let lastSize = false;
      for (let size of this.sizes) {

        let mediaQueries = [];
        if (lastSize) {
          mediaQueries.push(`(min-${this.sizingDimension}:${lastSize + 1}px)`);
        }
        if (size !== largest) {
          mediaQueries.push(`(max-${this.sizingDimension}:${size}px)`);
        }
        sources.push(<source
          key={`${size}.${fileExt}`}
          srcSet={this.props.pathForContent(formattedImgPath(this.props.src, {[this.sizingDimension]: size}, fileExt))}
          type={contentType}
          media={mediaQueries.join(' and ')} />);
        lastSize = size;
      }
    }
    return sources;
  }

  get srcBase () {
    return pathlib.dirname(this.props.src) + pathlib.basename(this.props.src, pathlib.extname(this.props.src));
  }

  get sizingDimension () {
    if (this.props.widths) {
      return 'width';
    }
    if (this.props.heights) {
      return 'height';
    }
    throw new Error('You must specify specify either widths OR heights for a <Picture />');
  }

  get sizes () {
  if (this.props.widths && this.props.heights) {
      throw new Error('You cannot specify both widths AND heights for a <Picture />');
    }
    if (!this.props.widths && !this.props.heights) {
      throw new Error('You must specify either widths OR heights for a <Picture />');
    }

    return (this.props.widths || this.props.heights).slice().sort((a, b) => a - b);
  }

  render () {

    let largest = this.sizes[this.sizes.length - 1];
    let defaultExt = this.props.formats[this.props.formats.length - 1].fileExt;
    if (this.props.src) {
      return (<picture>
        {this.renderSources(largest)}
        <img className={this.props.className} src={this.props.pathForContent(formattedImgPath(this.props.src, {[this.sizingDimension]: largest}, defaultExt))} />

      </picture>);
    } else if (this.props.imagePath) {
      return (<picture><ContentImg src={this.props.imagePath} /></picture>);
    } else {
      return null
    }
  }
}

Picture.propTypes = {
  widths: PropTypes.arrayOf(PropTypes.number),
  heights: PropTypes.arrayOf(PropTypes.number),
  formats: PropTypes.arrayOf(PropTypes.shape({
    fileExt: PropTypes.string,
  })),
  src: PropTypes.string,
  imagePath: PropTypes.string,
  className: PropTypes.string,
  pathForContent: PropTypes.func,
};


export default connectToPathForContent(Picture);



// WEBPACK FOOTER //
// ./lib/rlink-repos/components/Picture.jsx